export default __webpack_public_path__ + "static/media/time.619c507d.jpg";